<template>
  <div>
    <el-card>
      <div class="block">
        <el-form :inline="true">
          <el-form-item label="数据类型:">
            <el-select v-model="dataType" placeholder="请选择数据类型">
              <el-option v-for="item in types" :key="item.key" :value="item.key" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对冲账号:">
            <el-select v-model="account" placeholder="请选择对冲账号">
              <el-option v-for="item in hedgeAccountEnum" :key="item.key" :value="item.key" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" v-if="binanceSpot === 0 && isGate === 0">
            <el-date-picker
                v-model="dateRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="币种类型或者交易对:">
            <el-input v-model="coinType" placeholder="请输入币种类型或交易对"></el-input>
          </el-form-item>
          <el-form-item label="交易ID:" v-if="binanceSpot === 1 && direction === 0">
            <el-input v-model="fromId" placeholder="请输入交易ID" type="number"></el-input>
          </el-form-item>
          <el-form-item label="是否同步">
            <el-switch
                v-model="synchronization"
                active-text="开"
                inactive-text="关">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :plain="true" @click="syncExchangeAccountReconciliationData">查询</el-button>
          </el-form-item>
        </el-form>

        <div class="top" v-if="isShow">
          <el-table :data="tradeTable" style="width: 100%" max-height="1000" border v-if="direction===0">
            <el-table-column prop="exchange" label="对冲账号" sortable></el-table-column>
            <el-table-column prop="accountWalletType" label="账户类型" sortable></el-table-column>
            <el-table-column prop="pair" label="交易对" sortable></el-table-column>
            <el-table-column prop="tradeId" label="交易ID" sortable></el-table-column>
            <el-table-column prop="price" label="价格" sortable></el-table-column>
            <el-table-column prop="amount" label="数量" sortable></el-table-column>
            <el-table-column prop="direction" label="成交方向" sortable></el-table-column>
            <el-table-column prop="fee" label="手续费" sortable></el-table-column>
            <el-table-column prop="feeCoin" label="手续费币种" sortable></el-table-column>
            <el-table-column prop="confirmBenefit" label="收益" sortable></el-table-column>
            <el-table-column prop="accountBalanceCurrency" label="账户余额币种" sortable></el-table-column>
            <el-table-column prop="balanceChange" label="变动余额" sortable></el-table-column>
            <el-table-column prop="accountBalance" label="账户余额" sortable></el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          </el-table>
          <el-table :data="transferTable" style="width: 100%" max-height="1000" border v-if="direction===1">
            <el-table-column prop="exchange" label="对冲账号" sortable></el-table-column>
            <el-table-column prop="coin" label="币种类型" sortable></el-table-column>
            <el-table-column prop="amount" label="数量" sortable></el-table-column>
            <el-table-column prop="toAddr" label="目标账号" sortable v-if="binanceSub === 1"></el-table-column>
            <el-table-column prop="fromAddr" label="转出账号" sortable v-if="binanceSub === 0"></el-table-column>
            <el-table-column prop="toAddr" label="转入账号" sortable v-if="binanceSub === 0"></el-table-column>
            <el-table-column prop="transactType" label="划转类型" sortable></el-table-column>
            <el-table-column prop="accountType" label="账户类型" sortable></el-table-column>
            <el-table-column prop="state" label="状态" sortable></el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          </el-table>
          <el-table :data="depositWithdrawTable" style="width: 100%" max-height="1000" border v-if="direction===2">
            <el-table-column prop="exchange" label="对冲账号" width="110" sortable></el-table-column>
            <el-table-column prop="coin" label="币种类型" width="110" sortable></el-table-column>
            <el-table-column prop="direction" label="方向" width="110" sortable></el-table-column>
            <el-table-column prop="amount" label="数量" width="80" sortable></el-table-column>
            <el-table-column prop="tradeId" label="交易ID" sortable></el-table-column>
            <el-table-column prop="depositAddr" label="充值地址" sortable></el-table-column>
            <el-table-column prop="withdrawAddr" label="提现地址" sortable></el-table-column>
            <el-table-column prop="state" label="状态" width="120" sortable></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" sortable></el-table-column>
          </el-table>
          <div>
            <span v-if="direction===0">当前一共有{{ tradeTable.length }}条数据</span>
            <span v-if="direction===1">当前一共有{{ transferTable.length }}条数据</span>
            <span v-if="direction===2">当前一共有{{ depositWithdrawTable.length }}条数据</span>
          </div>
          <div style="text-align:right">
            <el-button type="success" plain @click="exportExcel()">导出excel</el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import './store'
import {mapActions, mapState} from "vuex";
import utils from "@/entries/HedgeCenter/BalanceBook/utils";

const depositColumns=[
  {title:'对冲账号',key:'exchange'},
  {title:'币种类型',key:'coin'},
  {title:'方向',key:'direction'},
  {title:'数量',key:'amount'},
  {title:'交易ID',key:'tradeId'},
  {title:'充值地址',key:'depositAddr'},
  {title:'提现地址',key:'withdrawAddr'},
  {title:'状态',key:'state'},
  {title:'创建时间',key:'createTime'}
]

const tradeColumns=[
  {title:'对冲账号',key:'exchange'},
  {title:'账户类型',key:'accountWalletType'},
  {title:'交易对',key:'pair'},
  {title:'交易ID',key:'tradeId'},
  {title:'价格',key:'price'},
  {title:'数量',key:'amount'},
  {title:'成交方向',key:'direction'},
  {title:'手续费',key:'fee'},
  {title:'手续费币种',key:'feeCoin'},
  {title:'收益',key:'confirmBenefit'},
  {title:'账户余额币种',key:'accountBalanceCurrency'},
  {title:'变动余额',key:'balanceChange'},
  {title:'账户余额',key:'accountBalance'},
  {title:'创建时间',key:'createTime'}
]

const transferColumns=[
  {title:'对冲账号',key:'exchange'},
  {title:'币种类型',key:'coin'},
  {title:'数量',key:'amount'},
  {title:'转出账号',key:'fromAddr'},
  {title:'转入账号',key:'toAddr'},
  {title:'划转类型',key:'transactType'},
  {title:'账户类型',key:'accountType'},
  {title:'状态',key:'state'},
  {title:'创建时间',key:'createTime'}
]

const transferColumnsOther=[
  {title:'对冲账号',key:'exchange'},
  {title:'币种类型',key:'coin'},
  {title:'数量',key:'amount'},
  {title:'目标账号',key:'toAddr'},
  {title:'划转类型',key:'transactType'},
  {title:'账户类型',key:'accountType'},
  {title:'状态',key:'state'},
  {title:'创建时间',key:'createTime'}
]

const dataTypeOp = [
  {label:'交易',key:'TRADE'},
  {label:'划转',key:'TRANSFER'},
  {label:'充提',key:'DEPOSIT_WITHDRAW'},
]

const pickerOptions = {
  shortcuts: [
    {
      text: '最近一天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近三天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*3);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一周',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*7);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近十天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*10);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*30);picker.$emit('pick', [start, end]);}
    }
  ]
}

export default {
  name: "LackRecords",
  data(){
    return {
      direction:'',
      binanceSub:'',
      fromId:null,
      pages:0,
      total:0,
      buffer:'',
      dataType:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      binanceSpot:false,
      isGate:false,
      account:'',
      coinType: '',
      activeName:'part1',
      types:dataTypeOp,
      dateRange:[],
      depositWithdrawTable:[],
      transferTable:[],
      tradeTable:[],
      restaurants:[],
      pickerOptions: pickerOptions,
      synchronization:false,
    }
  },
  methods:{

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryHedgeHistoryDepositWithdraw()
    },

    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryHedgeHistoryDepositWithdraw()
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },

    handleSelect(item) {},
    handleIconClick(ev) {},

    syncExchangeAccountReconciliationData (){
      if (this.dataType === ""){
        this.$message.error("请选择对账类型")
        return
      }
      if (this.account === ""){
        this.$message.error("请选择平台账号")
        return
      }
      if (this.binanceSpot === 0 && this.isGate === 0){
        if (this.dateRange.length === 0){
          this.$message.error("请选择日期")
          return
        }
        if ((this.params.endTime - this.params.startTime) > 3600*1000*24*30){
          this.$message.error("一次可查询的数据不能超过30天")
          return
        }
      }
      utils.syncExchangeAccountReconciliationData(this.params).then((response=>{
        this.isShow = true
        let tableData = (response.data !== null)?response.data:[]
        for (let key in tableData){
          tableData[key].createTime = utils.getLocalTime(tableData[key].createTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
        }
        if (this.params.dataType === 'TRADE'){
          this.tradeTable = tableData
        }
        if (this.params.dataType === 'TRANSFER'){
          this.transferTable = tableData
        }
        if (this.params.dataType === 'DEPOSIT_WITHDRAW'){
          this.depositWithdrawTable = tableData
        }

      }))
    },

    exportExcel (){
      let title = '对账数据' + this.params.startTime + '-' + this.params.endTime
      if (this.params.dataType === 'TRADE'){
        utils.export2Excel(tradeColumns, this.tradeTable, title)
      }
      if (this.params.dataType === 'TRANSFER'){

        if (this.binanceSub === 0) {
          utils.export2Excel(transferColumns, this.transferTable, title)
        }
        else {
          utils.export2Excel(transferColumnsOther, this.transferTable, title)
        }
      }
      if (this.params.dataType === 'DEPOSIT_WITHDRAW'){
        utils.export2Excel(depositColumns, this.depositWithdrawTable, title)
      }
    }

  },
  computed: {
    ...mapState('balanceReconciliation', ['hedgeAccountEnum']),
    params() {
      return {
        startTime:isNaN(new Date(this.dateRange[0]).getTime()) ? 0: new Date(this.dateRange[0]).getTime(),
        endTime:isNaN(new Date(this.dateRange[1]).getTime()) ? 1: new Date(this.dateRange[1]).getTime(),
        dataType: this.dataType,
        pairs: this.coinType,
        account: this.account,
        synchronization: this.synchronization,
        fromId: this.fromId
      };
    },
  },
  created() {
  },
  watch:{
    'dataType'(val){
      if (val === 'TRADE') {
        this.direction = 0
      }
      if (val === 'TRANSFER'){
        this.direction = 1
      }
      if (val === 'DEPOSIT_WITHDRAW'){
        this.direction = 2
      }
    },
    'account'(val){
      if (val === "BINANCE" || val === "BINANCE0" || val === "BINANCE2") { this.binanceSub = 1} else { this.binanceSub = 0 }
      if (val === "BINANCE0" || !val.startsWith("BINANCE")) { this.binanceSpot = 0 } else { this.binanceSpot = 1}
      if (val.startsWith("GATE")){this.isGate = 1} else { this.isGate = 0 }
    }
  },
}
</script>

<style scoped>

</style>